import { EyeFilled } from "@ant-design/icons";
import { Button, Form, Input, Select, TableProps } from "antd";
import Dragger from "antd/es/upload/Dragger";
import { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import { useAppSelector } from "../../../../app/store";
import DownloadIcon from "../../../../assets/icons/DownloadIcon";
import SelectDownIcon from "../../../../assets/icons/SelectDownIcon";
import CustomModal from "../../../../components/ui/CustomModal";
import CustomTable from "../../../../components/ui/CustomTable";
import {
  useCreateBatchMutation,
  useGetAllDisbursementTypeQuery,
} from "../../../../features/portal/batch/batchApi";
import { useGetUserWalletRoleByUserIdQuery } from "../../../../features/portal/companyOnboard/companyOnboardApi";
import useError from "../../../../hooks/useError";
import useModal from "../../../../hooks/useModal";
import useTable from "../../../../hooks/useTable";
import { toast } from "../../../../lib/toast";
import { stringToArray } from "../../../../utils/array";
import { countParPageSerialNumber } from "../../../../utils/number";
import { capitalize, sliceString } from "../../../../utils/string";
import { addKeyInArray } from "../../../../utils/utils";

type Props = {
  open: boolean;
  handleClose: (val?: any) => void;
  batchCode?: string;
  batchName?: string;
  id?: string | number;
  walletId?: any;

  // data?: any;
  // reRender: (val: boolean) => void;
  // uploadedCount: (val: number, total: number) => void;
};

export default function PaymentSalaryDisModal({
  open,
  handleClose,
  batchCode,
  batchName,
  id,
  walletId,
}: // data: tableLength,
// reRender,
// uploadedCount,
Props) {
  const [selectedData, setSelectedData] = useState<string[]>([]);
  const {
    page,
    limit,
    handlePagination,
    handleFilter,
    handleLimit,
    filter,
    keyword,
    handleSearch,
  } = useTable();
  const [form] = Form.useForm();

  const [fileName, setFileName] = useState("No file chosen");
  const [loading, setLoading] = useState(false);
  const [uploadedData, setUploadedData] = useState<any[]>([]);
  const projectId = localStorage.getItem("product_id");
  const { user } = useAppSelector((state) => state.auth);

  const {
    open: openPreview,
    handleOpen: handlePreviewOpen,
    handleClose: handleClosePreview,
  } = useModal();

  // const [createDisbursements, { isLoading, isError, error, isSuccess }] =
  //   useCreateDisbursementsMutation();

  // const {
  //   data: getSingleUserWalletRoleData,
  //   isError: getSingleUserWalletRoleIsError,
  //   error: getSingleUserWalletRoleError,
  // } = useGetSingleUserWalletRoleQuery(
  //   {
  //     walletId: walletId ? Number(walletId) : undefined,
  //     userId: user?.data?.id,
  //   },
  //   { skip: !walletId || !user?.data?.id }
  // );

  const [
    createBatch,
    {
      isError: isCreateBatchError,
      error: createBatchError,
      isLoading: isCreateBatchLoading,
      isSuccess: isCreateBatchSuccess,
    },
  ] = useCreateBatchMutation();

  const {
    data: getAllDisbursementTypeData,
    isError: getAllDisbursementTypeIsError,
    error: getAllDisbursementTypeError,
  } = useGetAllDisbursementTypeQuery({
    params: {
      is_active: true,
    },
  });

  const {
    data: userWalletsData,
    isError: userWalletsIsError,
    error: userWalletsError,
    isLoading: userWalletsIsLoading,
  } = useGetUserWalletRoleByUserIdQuery(
    {
      id: Number(user?.data?.id),
      search: keyword,
      page,
      limit,
    },
    {
      skip: !user?.data?.id,
    }
  );

  // const {
  //   data: getCompanyWalletData,
  //   isError: getCompanyWalletIsError,
  //   error: getCompanyWalletError,
  // } = useGetCompanyWalletQuery(
  //   {
  //     params: {
  //       company_id: user?.data?.company_id,
  //     },
  //   },
  //   {
  //     skip: !user?.data?.company_id,
  //   }
  // );

  // useError(isError, error, "Salary disbursement data upload fail");
  useError(
    userWalletsIsError,
    userWalletsError,
    "Get User Wallet Role By User Id failed"
  );
  useError(
    isCreateBatchError,
    createBatchError,
    "Salary disbursement data uploaded fail"
  );
  useError(
    getAllDisbursementTypeIsError,
    getAllDisbursementTypeError,
    "Get disbursement type fail"
  );
  // useError(
  //   getCompanyWalletIsError,
  //   getCompanyWalletError,
  //   "Get company wallet fail"
  // );

  // useError(
  //   getSingleUserWalletRoleIsError,
  //   getSingleUserWalletRoleError,
  //   "Get single user wallet role failed"
  // );

  const makerRolesData = userWalletsData?.data?.walletRoles?.filter(
    (item) => item.role === "maker"
  );

  const onFinish = async (values: any) => {
    if (!uploadedData?.length) {
      toast(
        "error",
        "Data is empty! please uploaded salary disbursement excel again"
      );
      return;
    }

    const newDataDirectExcel = uploadedData.map(
      ({ name, ...rest }: any) => rest
    );
    const newDataSelect = selectedData.map(
      ({ name, key, ...rest }: any) => rest
    );

    const nameData = values?.batchName;

    const apiUploadData = {
      batch: {
        name: nameData,
        company_id: Number(user?.data?.company_id),
        project_id: Number(projectId),
        created_by: Number(user?.data?.id),
        dis_type: values?.dis_type,
        wallet_number: values?.wallet_number,
        // wallet_tag_id: values?.wallet_tag_id,
      },
      salaryDisbursement:
        selectedData.length === 0 ? newDataDirectExcel : newDataSelect,
    };

    // console.log("Excel upload data", apiUploadData);

    createBatch(apiUploadData);
  };

  const handleUploadFile = (file: any) => {
    if (
      file?.name?.endsWith(".xls") ||
      file?.name?.endsWith(".xlsx") ||
      file?.type === "application/vnd.ms-excel" ||
      file?.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
      setLoading(true);
      const reader = new FileReader();
      reader.readAsBinaryString(file);

      const fileNameArr = stringToArray(file?.name, ".");
      setFileName(
        `${sliceString(file?.name, 30, "...")}.${
          fileNameArr?.[fileNameArr?.length - 1]
        }`
      );

      reader.onload = (e) => {
        const data = e?.target?.result;
        const workBook = XLSX.read(data, {
          type: "binary",
          cellDates: true,
          dateNF: "mm/dd/yyyy",
        });
        const sheetName = workBook.SheetNames[0];
        const sheet = workBook.Sheets[sheetName];
        let parsedData = XLSX.utils.sheet_to_json(sheet, {
          raw: false,
          defval: "",
        });

        const firstRow = parsedData[0] || {};
        const departmentKey = Object.keys(firstRow).find(
          (key) => key.trim().toLowerCase() === "department"
        );

        // Mapping and structuring data with required fields
        const transformedData = parsedData.map((el: any) => {
          let wallet_number =
            el?.["wallet_number"]?.trim() ||
            el?.["Wallet Number"]?.trim() ||
            "";

          if (wallet_number && !wallet_number.startsWith("88")) {
            wallet_number = `88${wallet_number}`;
          }

          const bank_name =
            el?.["bank_name"]?.trim() || el?.["Bank Name"]?.trim() || "";
          const account_title =
            el?.["account_title"]?.trim() ||
            el?.["Account Title"]?.trim() ||
            "";
          const account_number =
            el?.["account_number"]?.trim() ||
            el?.["Account Number"]?.trim() ||
            "";
          const branch_name =
            el?.["branch_name"]?.trim() || el?.["Branch Name"]?.trim() || "";
          const routing_number =
            el?.["routing_number"]?.trim() ||
            el?.["Routing Number"]?.trim() ||
            "";

          let disbursement_type = "";
          if (wallet_number) {
            disbursement_type = "wallet";
          } else if (
            bank_name ||
            account_title ||
            account_number ||
            branch_name ||
            routing_number
          ) {
            disbursement_type = "bank";
          }

          // --- Validation logic for amount ---
          const amount = Number(el?.["amount"] || el?.["Amount"] || 0);

          return {
            name: fileNameArr?.[0] || "",
            company_id: Number(user?.data?.company_id),
            employee_id:
              el?.["employee_id"]?.trim() || el?.["Employee ID"]?.trim() || "",
            employee_name:
              el?.["employee_name"]?.trim() ||
              el?.["Employee Name"]?.trim() ||
              "",
            department: departmentKey ? el[departmentKey]?.trim() || "" : "",
            designation:
              el?.["designation"]?.trim() || el?.["Designation"]?.trim() || "",
            wallet_number,
            bankData: {
              bank_name,
              account_title,
              account_number,
              branch_name,
              routing_number,
            },
            amount,
            narration:
              el?.["narration"]?.trim() || el?.["Narration"]?.trim() || "",
            status: "pending",
            remarks: el?.["remarks"]?.trim() || el?.["Remarks"]?.trim() || "",
            disbursement_type,
          };
        });

        // --- Validation: Check if any amount is less than 100 ---
        const invalidRow = transformedData.find((row: any) => row.amount < 10);
        if (invalidRow) {
          toast("error", "Amount cannot be less than 10 in any row.");
          setLoading(false);
          return;
        }

        // --- Validation: Check if any account_number contains letters ---
        const invalidAccount = transformedData.find(
          (row: any) =>
            row.bankData.account_number &&
            /[a-zA-Z]/.test(row.bankData.account_number)
        );
        if (invalidAccount) {
          toast("error", "Account number must not contain letters in any row.");
          setLoading(false);
          return;
        }

        setUploadedData(transformedData);
        setLoading(false);
      };
    } else {
      setLoading(false);
      toast("error", "Please upload only excel file");
    }
  };

  useEffect(() => {
    if (isCreateBatchSuccess) {
      toast("success", "Salary disbursement data uploaded successfully");
      handleClose(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCreateBatchSuccess]);

  const columns: TableProps<any>["columns"] = [
    {
      title: "#SL",
      align: "center",
      width: 60,
      render: (_, __, index) => countParPageSerialNumber(page, limit, index),
    },
    {
      title: <div className="whitespace-nowrap !w-[120px]">File Name</div>,
      dataIndex: "name",
      render: (val) => (val ? val : "N/A"),
    },
    {
      title: <div className="whitespace-nowrap !w-[120px]">Company ID</div>,
      dataIndex: "company_id",
      align: "center",
      render: (val) => (val ? val : "N/A"),
    },
    {
      title: <div className="whitespace-nowrap !w-[120px]">Employee ID</div>,
      dataIndex: "employee_id",
      align: "center",
      render: (val) => (val ? val : "N/A"),
    },
    {
      title: <div className="whitespace-nowrap !w-[120px]">Employee Name</div>,
      dataIndex: "employee_name",
      render: (val) => (val ? val : "N/A"),
    },

    {
      title: <span className="whitespace-nowrap">Department</span>,
      align: "center",
      dataIndex: "department",
      render: (val) => (val ? val : "N/A"),
    },

    {
      title: <span className="whitespace-nowrap">Designation</span>,
      align: "center",
      dataIndex: "designation",
      render: (val) => (val ? val : "N/A"),
    },
    {
      title: <span className="whitespace-nowrap">Amount</span>,
      align: "center",
      dataIndex: "amount",
      render: (val: string | number) => (
        <>
          {val
            ? Number(val)
                .toFixed(2)
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            : "0"}
        </>
      ),
    },
    {
      title: (
        <div className="whitespace-nowrap !w-[120px]">Disbursement Type</div>
      ),
      dataIndex: "disbursement_type",
      align: "center",
      render: (val) => (val ? capitalize(val) : "N/A"),
    },

    {
      title: <span className="whitespace-nowrap">Wallet Number</span>,
      align: "center",
      dataIndex: "wallet_number",
      render: (val) => (val ? val : "N/A"),
    },
    {
      title: <span className="whitespace-nowrap">Bank Name</span>,
      align: "center",
      dataIndex: "bankData",
      render: (val) => (val?.bank_name ? val?.bank_name : "N/A"),
    },
    {
      title: <span className="whitespace-nowrap">Account Title</span>,
      align: "center",
      dataIndex: "bankData",
      render: (val) => (val?.account_title ? val?.account_title : "N/A"),
    },
    {
      title: <span className="whitespace-nowrap">Account Number</span>,
      align: "center",
      dataIndex: "bankData",
      render: (val) => (val?.account_number ? val?.account_number : "N/A"),
    },
    {
      title: <span className="whitespace-nowrap">Branch Name</span>,
      align: "center",
      dataIndex: "bankData",
      render: (val) => (val?.branch_name ? val?.branch_name : "N/A"),
    },
    {
      title: <span className="whitespace-nowrap">Routing Number</span>,
      align: "center",
      dataIndex: "bankData",
      render: (val) => (val?.routing_number ? val?.routing_number : "N/A"),
    },
    {
      title: <span className="whitespace-nowrap">Narration</span>,
      align: "center",
      dataIndex: "narration",
      render: (val) => (val ? val : "N/A"),
    },
    {
      title: <span className="whitespace-nowrap">Remarks</span>,
      align: "center",
      dataIndex: "remarks",
      render: (val) => (val ? val : "N/A"),
    },
    {
      title: <span className="whitespace-nowrap">Status</span>,
      align: "center",
      dataIndex: "status",
      render: (val) => (val ? capitalize(val) : "N/A"),
    },
  ];

  return (
    <>
      <CustomModal
        width={600}
        title="Disbursement Info"
        open={open}
        handleClose={handleClose}
        footer={null}
      >
        <div className="p-6">
          <label className="text-[#3d4a5c] text-sm font-medium leading-normal mb-1.5 inline-block">
            Import Disbursment File
          </label>
          <Dragger
            name="file"
            action=""
            accept=".xlsx, .xls"
            maxCount={1}
            showUploadList={false}
            beforeUpload={() => false}
            onChange={(info) => handleUploadFile(info.file)}
            onDrop={(e) => handleUploadFile(e.dataTransfer.files[0])}
            // excelPostLoading ||
            disabled={isCreateBatchLoading}
            className="import_excel mb-5 excel-upload"
          >
            <Button
              className="flex justify-between items-center disabled:!bg-transparent"
              size="large"
              disabled={isCreateBatchLoading}
              style={{ width: "100%" }}
            >
              <div className="flex items-center gap-2 text-sm font-normal font-roboto text-[#8797ae]">
                <span className="text-accent font-medium text-base leading-7 relative">
                  Choose File
                </span>
                <span className="border-r border-solid border-l-0 border-y-0 border-others-border h-4" />
                {loading ? "Uploading..." : fileName}
              </div>
            </Button>
          </Dragger>
          <div className="flex items-center gap-1.5 mt-1 mb-3">
            <span className="text-body-text text-sm leading-normal">
              Download Sample File
            </span>
            <Button
              className="download-button !p-0 !h-fit !border-none !shadow-none !font-semibold"
              size="small"
              icon={<DownloadIcon />}
              type="link"
              href="/Salary Disbursement Format.xlsx"
              target="_blank"
              download
            >
              Download
            </Button>
            {!uploadedData.length ? null : (
              <Button
                className="download-button !p-0 !h-fit !border-none !shadow-none !font-semibold"
                size="small"
                icon={<EyeFilled />}
                onClick={() => handlePreviewOpen({ type: "VIEW" })}
              >
                Preview
              </Button>
            )}
          </div>

          <Form
            className="custom-form"
            layout="vertical"
            requiredMark="optional"
            size="large"
            onFinish={onFinish}
            form={form}
            // initialValues={{
            //   dis_type: "salary",
            // }}
          >
            <Form.Item
              label="Batch Name"
              name="batchName"
              rules={[
                {
                  required: true,
                  message: "Please enter the disbursement batch name",
                },
              ]}
            >
              <Input placeholder="Enter disbursement batch name" />
            </Form.Item>

            {/* <Form.Item
              label="Disbursement Type"
              name="dis_type"
              rules={[
                {
                  required: false,
                  message: "Please enter the disbursement type",
                },
              ]}
            >
              <Select
                placeholder="Disbursement Type"
                suffixIcon={<SelectDownIcon />}
                options={[{ label: "Salary", value: "salary" }]}
                className="min-w-[100px] w-full mb-4 "
              />
            </Form.Item> */}

            <Form.Item
              label="Disbursement Type"
              name="dis_type"
              rules={[
                {
                  required: true,
                  message: "Please select the disbursement type",
                },
              ]}
            >
              <Select
                placeholder="Disbursement Type"
                suffixIcon={<SelectDownIcon />}
                options={getAllDisbursementTypeData?.data?.map((item: any) => ({
                  label: item.name,
                  value: item.name,
                }))}
                className="min-w-[100px] w-full "
                allowClear
              />
            </Form.Item>

            {/* <Form.Item
              label="Wallet Number"
              name="wallet_number"
              rules={[
                {
                  required: true,
                  message: "Please select the wallet number",
                },
              ]}
            >
              <Select
                placeholder="Wallet Number"
                suffixIcon={<SelectDownIcon />}
                options={
                  getCompanyWalletData?.data
                    ? [
                        {
                          label: getCompanyWalletData?.data?.wallet_number,
                          value: getCompanyWalletData?.data?.wallet_number,
                        },
                      ]
                    : []
                }
                className="min-w-[100px] w-full mb-4"
              />
            </Form.Item> */}

            <Form.Item
              label="Wallet Number"
              name="wallet_number"
              rules={[
                {
                  required: true,
                  message: "Please select the wallet number",
                },
              ]}
            >
              <Select
                placeholder="Wallet Number"
                suffixIcon={<SelectDownIcon />}
                options={makerRolesData?.map((item: any) => ({
                  label: item?.wallet?.wallet_number,
                  value: item?.wallet?.wallet_number,
                }))}
                className="min-w-[100px] w-full"
              />
            </Form.Item>

            {/* <Form.Item
              label="Tags"
              name="wallet_tag_id"
              rules={[
                {
                  required: true,
                  message: "Please select the tags",
                },
              ]}
            >
              <Select
                placeholder="Tags"
                suffixIcon={<SelectDownIcon />}
                options={
                  getSingleUserWalletRoleData?.data?.wallet?.tags?.map(
                    (tag: any) => ({
                      label: tag?.name,
                      value: tag?.id,
                    })
                  ) || []
                }
                className="min-w-[100px] w-full"
              />
            </Form.Item> */}

            <div className="flex justify-center mt-7">
              <Button
                size="large"
                type="primary"
                className="w-72 !h-12"
                htmlType="submit"
                loading={isCreateBatchLoading}
              >
                Upload
              </Button>
            </div>
          </Form>
        </div>

        <CustomModal
          title="Salary Disbursement Preview"
          open={openPreview.open}
          handleClose={handleClosePreview}
          width={900}
          footer={null}
        >
          <CustomTable
            loading={false}
            limit={limit}
            page={page}
            columns={columns}
            total={uploadedData.length}
            dataSource={addKeyInArray(uploadedData)}
            handleLimit={handleLimit}
            handlePagination={handlePagination}
            rowSelection={{
              type: "checkbox",
              // selectedRowKeys: selectedData,
              onChange: (_selectedRowKeys, selectedRows) => {
                setSelectedData(selectedRows);
              },
              getCheckboxProps: (record) => {
                return {
                  disabled: record?.status === "invited",
                };
              },
              columnWidth: 40,
            }}
            filterSection={
              <Button
                type="primary"
                className="px-3"
                onClick={() => handleClosePreview()}
                disabled={selectedData.length === 0}
              >
                Submit
              </Button>
            }
          />
        </CustomModal>
      </CustomModal>
    </>
  );
}
